import { Auth0Error, Auth0Result } from "auth0-js";
import { authenticationClient } from "../clients";
import authParams from "../params";
import { getUserInfo } from "./getUserInfo";
import { SuccessfulAuth } from "../../auth/authSlice";

const { realm } = authParams;

interface Props {
  email: string;
  password: string;
}

const login = ({ email, password }: Props) =>
  new Promise<SuccessfulAuth>((resolve, reject) =>
    authenticationClient.login(
      { username: email, password, realm },
      (error: Auth0Error | null, result: Auth0Result) => {
        if (
          error ||
          !result.accessToken ||
          !result.idToken ||
          !result.refreshToken ||
          !result.expiresIn
        ) {
          reject(error);
        } else {
          const { accessToken, idToken, refreshToken, expiresIn } = result;
          getUserInfo({ accessToken, idToken, refreshToken, expiresIn })
            .then(resolve)
            .catch(reject);
        }
      },
    ),
  );

export { login };
